import { render, staticRenderFns } from "./TgbAvatarList.vue?vue&type=template&id=7af2eadc&scoped=true"
import script from "./TgbAvatarList.vue?vue&type=script&lang=js"
export * from "./TgbAvatarList.vue?vue&type=script&lang=js"
import style0 from "./TgbAvatarList.vue?vue&type=style&index=0&id=7af2eadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2eadc",
  null
  
)

export default component.exports